import { render } from "./SectionWelcomeReference.vue?vue&type=template&id=3fb34af1&scoped=true"
import script from "./SectionWelcomeReference.vue?vue&type=script&lang=js"
export * from "./SectionWelcomeReference.vue?vue&type=script&lang=js"

import "./SectionWelcomeReference.vue?vue&type=style&index=0&id=3fb34af1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb34af1"]])

export default __exports__